module.exports = [{"value":null,"text":"= Please Select Room ID =","disabled":true,"selected":true},"Exyte Training (Canteen Area)"]


//////////////////
// WEBPACK FOOTER
// ./static/roomId.json
// module id = ./static/roomId.json
// module chunks = 0 1 2 3 4 6 10